import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["input", "error", "submit", "spinner"]
  static values = { eventId: Number, errorMessage: String }

  disconnect() {
    this.request?.abort()
  }

  focus() {
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  async save(event) {
    event.preventDefault()
    if (this.submitTarget.disabled) return

    this.errorTarget.classList.add("d-none")
    this.setLoading(true)
    this.request = new AbortController()

    try {
      const response = await fetch(event.currentTarget.action, {
        method: "PATCH",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        },
        body: JSON.stringify({ event: { sneas_identifier: this.inputTarget.value } }),
        signal: this.request.signal
      })
      const data = await response.json()
      if (this.request.signal.aborted) return
      if (!response.ok) {
        this.showError(data.errors?.join(" ") || this.errorMessageValue)
        return
      }
      if (data.event_id !== this.eventIdValue) throw new Error(this.errorMessageValue)

      this.inputTarget.value = data.sneas_identifier
      const summary = document.getElementById("screening_sneas_identifier")
      if (Number(summary?.dataset.eventId) === this.eventIdValue) {
        document.getElementById("screening_sneas_identifier_value").textContent = data.sneas_identifier
        document.getElementById("screening_sneas_identifier_warning")?.classList.add("d-none")
        const createButton = document.getElementById("screening_prefecture_submit")
        if (Number(createButton?.dataset.eventId) === this.eventIdValue) {
          createButton.disabled = createButton.dataset.screeningInitialized !== "true" || !(Number(createButton.dataset.pendingCount) > 0)
        }
      }
      Modal.getOrCreateInstance(this.element).hide()
    } catch (error) {
      if (error.name !== "AbortError") {
        this.showError(this.errorMessageValue)
      }
    } finally {
      this.setLoading(false)
    }
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("d-none")
  }

  setLoading(loading) {
    this.submitTarget.disabled = loading
    this.spinnerTarget.classList.toggle("d-none", !loading)
    this.spinnerTarget.setAttribute("aria-hidden", String(!loading))
  }
}
